import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {BaseComponent} from './views/theme/base/base.component';
import {ErrorPageComponent} from './views/theme/content/error-page/error-page.component';
import {ProductComponent} from './views/pages/product/product.component';
import {AdminGuard, AuthGuard, HotelAdminGuard, LoginGuard} from './provider/auth/all-guard.service';
import {PaymentComponent} from './views/pages/payment/payment.component';
import {CardInfoComponent} from './views/pages/payment/card-info/card-info.component';

const routes: Routes = [
  {path: 'auth', loadChildren: () => import('src/app/views/pages/auth/auth.module').then(m => m.AuthModule), canActivate: [LoginGuard]},

  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {path: 'home', loadChildren: () => import('src/app/views/pages/home/home.module').then(m => m.HomeModule)},
      {path: 'activity', loadChildren: () => import('src/app/views/pages/activity/activity.module').then(m => m.ActivityModule)},
      {path: 'product', component: ProductComponent, canActivate: [HotelAdminGuard]},
      {
        path: 'admin',
        loadChildren: () => import('src/app/views/pages/admin/admin.module').then(m => m.AdminModule),
        canActivate: [AdminGuard]
      },
      {
        path: 'error/403',
        component: ErrorPageComponent,
        data: {
          type: 'error-v6',
          code: 403,
          title: '403... Access forbidden',
          desc: 'Looks like you don\'t have permission to access for requested page.<br> Please, contact administrator'
        }
      },
      {path: 'users', loadChildren: () => import('src/app/views/pages/users/users.module').then(m => m.UserModule)},
      {path: 'analysis', loadChildren: () => import('src/app/views/pages/analysis/analysis.module').then(m => m.AnalysisModule)},
      {path: 'payment', component: PaymentComponent},
      {path: 'card-info', component: CardInfoComponent},


      {path: 'error/:type', component: ErrorPageComponent},
      {path: '', redirectTo: 'home', pathMatch: 'full'},
      {path: '**', redirectTo: 'home', pathMatch: 'full'},
    ]
  },

  {path: '**', redirectTo: 'error/403', pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
